import { render, staticRenderFns } from "./Assignment.vue?vue&type=template&id=585380e2&scoped=true&"
import script from "./Assignment.vue?vue&type=script&lang=js&"
export * from "./Assignment.vue?vue&type=script&lang=js&"
import style0 from "./Assignment.vue?vue&type=style&index=0&id=585380e2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585380e2",
  null
  
)

export default component.exports